<template>
  <v-text-field
    :rules="rules"
    v-bind="fieldProps"
    name="city"
    label="Cidade"
    autocomplete="city"
  ></v-text-field>
</template>

<script>
import { requiredValidation } from "../../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite sua cidade.")],
  }),
  mixins: [mixin],
};
</script>
